/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Stack, Paper, Typography, Divider, Grid, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik } from "formik";
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";

import Switch from "../../../../components/form/Switch";
import InputText from "../../../../components/form/InputText";
import Notification from "../../../../components/form/Notification";
import Alert from "../../../../components/form/Alert";
import Skeleton from "../../../../components/form/Skeleton";
import Autocomplete from "../../../../components/form/AutoComplete";
import NumericFormatPhone from '../../../../components/form/FormatPhone';
import validator from "./validator";
import SaveIcon from '@mui/icons-material/Save';
import LogsModal from "./LogsModal";
import HistoryIcon from '@mui/icons-material/History';
import { exportToExcel } from "react-json-to-excel";
import { PersonAdd, LocalShipping } from '@mui/icons-material';


import FilesModal from "./FilesModalProvider";
import { useCanView } from "../../../../config/hook/UserPermissions";
import { getProviderId } from "../../../../store/masters/thunk/provider/getId";
import { postProvider } from "../../../../store/masters/thunk/provider/post";
import { putProvider } from "../../../../store/masters/thunk/provider/put";
import { getLog } from "../../../../store/config/thunk/log/getAll";

const NewEdit = ({ setBtns }) => {
  const formikRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const canView = useCanView();
  const [__] = useTranslation("supplierMaster");
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const [showNoti, setShowNoti] = useState({
    open: false,
    msg: "",
    variant: "error",
    action: "post",
  });
  const [alert, setAlert] = useState({
    open: false,
    title: "",
    subtitle: "",
    type: "",
  });
  const [isMount, setIsMount] = useState(false);
  const [showGalery, setShowGalery] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const current = useSelector((state) => state.masters.provider.detail);
  const provider = useSelector((state) => state.masters.provider);
  const put = useSelector((state) => state.masters.provider.put);
  const post = useSelector((state) => state.masters.provider.post);
  const user = useSelector(state => state.auth.login.dataUser);
  const odooCode = useSelector(state => state.masters.provider.codesOdoo);

  const optionsCodeOdoo = map(odooCode?.data?.result,({ id, name }) => ({
    value: id,
    label: `${id} - ${name}`
}))

const logPeriodity = __(`logPeriodity`, { returnObjects: true });


  const userData = JSON.parse(localStorage.getItem('userData'));

  const municipalities = map(userData?.municipalities, ({ municipalityId, municipalityName }) => ({
      value: municipalityId,
      label: municipalityName,
  }))


  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" });
  };

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (
          <ul>
            {map(get(err, "ValidationError", []), (item) => (
              <li>{`• ${item}`}</li>
            ))}
          </ul>
        ),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert,
      });
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert,
      });
    }
  };

  useEffect(() => {
    if (get(put, "isSuccess", false)) {
      setShowNoti({ open: true, msg: "", variant: "success", action: "put" });
    }
    if (get(put, "isReject", false)) {
      setError(get(put, "error", {}), "put");
    }
    if (get(post, "isSuccess", false)) {
      setShowNoti({ open: true, msg: "", variant: "success", action: "post" });
    }
    if (get(post, "isReject", false)) {
      setError(get(post, "error", {}), "post");
    }
  }, [post, put]);

  useEffect(() => {
    if (searchParams.get("from") !== "new") {
      if (!!id) {
        let Screen = "PROVEEDORES"
        dispatch(getLog({page: 1, docId: Number(id), screen: String(Screen)}))
        dispatch(getProviderId({ id }));
      }
    }
  }, [dispatch, id, searchParams.get("from")]);

  const onSubmit = (values) => {

    if (canView("MAESTROS/PROVEEDORES", "update")) {

      const idProvider = Number(id);
  
      const body = {
        providerId: String(idProvider),
        comercialName: get(values, "commercialName", ""),
        legalName: get(values, "companyName", ""),
        muniId: get(values, "district", ""),
        address: get(values, "address", ""),
        phone: get(values, "phone", ""),
        email: get(values, "email", ""),
        corteId: get(values, "logPeriodicity", ""),
        providerOdooId: get(values, "odooCode", ""),
        isActive: get(values, "isActive", ""),
      }
         dispatch(putProvider(body));
    } else {
      setAlert({
        open: true,
        title: "Permiso Denegado.",
        subtitle: (<ul> • No tienes permiso para actualizar el proveedor.</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }

  };

  const initialValues = {
    isActive: id ? get(current, "data.isActive", "") === true ? true : false : true,
    commercialName: id ? get(current, "data.comercialName", "") : "",
    companyName: id ? get(current, "data.legalName", "") : "",
    email: id ? get(current, "data.email", "") : "",
    phone: id ? get(current, "data.phone", "") : "",
    address: id ? get(current, "data.address", "") : "",
    district: id ? get(current, "data.muniId", "") : "",
    odooCode: id ? get(current, "data.providerOdooId", "") : "",
    logPeriodicity: id ? get(current, "data.corteId", "") : "",
  };

  useEffect(() => {
    setBtns(
      <Stack className="mr-6" direction="row" spacing={2} justifyContent="flex-end">
        <Button
          className="w-[150px] min-w-[150px]"
          variant="outlined"
          color="secondary"
          startIcon={< HistoryIcon/>}
          onClick={() => {
            if (canView("MAESTROS/PROVEEDORES/LOGS", "watch")) {
              setOpenModal(true)
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para ver las modificaciones en proveedores.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
          }}
          // disabled={get(put, "isLoading")}
        >
         Ver Cambios
        </Button>
        <Grid item xs="auto" justifyContent="flex-end" display="flex">
            <Button
                variant="contained"
                color="info" // El color verde para el botón
                startIcon={<PersonAdd />} // Icono de exportar
                onClick={() =>  exportToExcel(current.data.drivers, 'Conductores')}
            >
                Conductores
            </Button>
        </Grid>
        <Grid item xs="auto" justifyContent="flex-end" display="flex">
            <Button
                variant="contained"
                color="info" // El color verde para el botón
                startIcon={<LocalShipping />} // Icono de exportar
                onClick={() =>  exportToExcel(current.data.transports, 'Camiones')}
            >
                Camiones
            </Button>
        </Grid>
        <Button className='w-[100px] min-w-[100px]' variant='text' color="secondary" onClick={() => {
        if (canView("MAESTROS/PROVEEDORES/ADJUNTOS", "watch")) {
          setShowGalery(true)
        } else {
          setAlert({
            open: true,
            title: "Permiso Denegado.",
            subtitle: (<ul> • No tienes permiso para ver los adjuntos del proveedor.</ul>),
            type: "error",
            btn: __(`${module}.actions.close`),
            func: closeAlert
          })
        }
        }} disabled={get(put, "isLoading")} >
          <div className='whitespace-nowrap'>Ver Adjuntos</div>
        </Button>
        <LoadingButton className='w-[100px] min-w-[100px]' startIcon={<SaveIcon/>} variant="contained" color="secondary" type="submit" form="form-provider" loading={get(put, "isLoading")}>{__(`action.save`)}</LoadingButton>
        <Button className="w-[100px] min-w-[100px]" variant="outlined"  color="secondary" onClick={() => navigate("/masters/providers/")} disabled={get(put, "isLoading")}>
          {__(`action.cancel`)}
        </Button>
      </Stack>
    );
  }, [get(put, "isLoading")]);

  return (
    <div>
      {get(current, "isLoading") ? (
        <Skeleton />
      ) : (
            <Formik innerRef={formikRef} initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
            {formik => (
                <form id="form-provider" onSubmit={get(formik, "handleSubmit")}>
                    <Paper className='mt-4'>
                        <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                            <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                            <Switch formik={formik} name="isActive" __={__} />
                        </Stack>
                        <Divider />
                        <Box className='p-4' >
                            <Grid container spacing={{ xs: 2, md: 3 }}>
                            <Grid item xs={12} sm={6} >
                                    <InputText
                                        formik={formik}
                                        name="commercialName"
                                        label={__(`form.commercialName.label`)}
                                        placeholder={__(`form.commercialName.placeholder`)}
                                        disabled={get(put, "isLoading", false)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} >
                                    <InputText
                                        formik={formik}
                                        name="companyName"
                                        label={__(`form.companyName.label`)}
                                        placeholder={__(`form.companyName.placeholder`)}
                                        disabled={get(put, "isLoading", false)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <InputText
                                        formik={formik}
                                        name="email"
                                        label={__(`form.email.label`)}
                                        placeholder={__(`form.email.placeholder`)}
                                        disabled={get(put, "isLoading", false)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <InputText
                                        formik={formik}
                                        name="phone"
                                        label={__(`form.phone.label`)}
                                        placeholder={__(`form.phone.placeholder`)}
                                        disabled={get(put, "isLoading", false)}
                                        InputProps={{
                                            inputComponent: NumericFormatPhone,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography className='pt-4' component="p" variant="bmr" color="text.lite" >{__(`labels.2`)}</Typography>
                                </Grid>
                              {/*} <Grid item xs={12} sm={6} md={12}> Para que se vea en toda la pantalla*/} 
                              <Grid item xs={12} sm={6}>
                                    <InputText
                                        formik={formik}
                                        name="address"
                                        label={__(`form.address.label`)}
                                        placeholder={__(`form.address.placeholder`)}
                                        disabled={get(put, "isLoading", false)}
                                        multiline
                                        rows={4}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} >
                                    <Autocomplete
                                        formik={formik}
                                        name="district"
                                        label={__(`form.district.label`)}
                                        placeholder={__(`form.district.placeholder`)}
                                        disabled={get(current, "isLoading", false) || get(put, "isLoading", false)}
                                        options={municipalities}
                                        loading={get(provider, "isLoading")}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography className='pt-4' component="p" variant="bmr" color="text.lite" >{__(`labels.3`)}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} >
                                    <Autocomplete
                                        formik={formik}
                                        name="odooCode"
                                        label={__(`form.odooCode.label`)}
                                        placeholder={__(`form.odooCode.placeholder`)}
                                        disabled={get(put, "isLoading", false)}
                                        loading={get(provider, "isLoading")}
                                        options={optionsCodeOdoo}
                                    />
                                </Grid> 
                                <Grid item xs={12} sm={6} >
                                    <Autocomplete
                                        formik={formik}
                                        name="logPeriodicity"
                                        label={__(`form.logPeriodicity.label`)}
                                        placeholder={__(`form.logPeriodicity.placeholder`)}
                                        disabled={get(put, "isLoading", false)}
                                        loading={get(provider, "isLoading")}
                                        options={logPeriodity}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </form>
            )}
        </Formik>
      )}
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <LogsModal
        __={__}
        open={openModal}
        close={() => setOpenModal(false)}
      />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <FilesModal
        __={__}
        open={showGalery}
        close={() => setShowGalery(false)}
      />
    </div>
  );
};

export default NewEdit;
